import {
  Component,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'ag-accordion-header',
  templateUrl: './accordion-header.component.html',
  styleUrls: ['./accordion-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, AngularSvgIconModule],
})
export class AccordionHeaderComponent {
  isActive = false;

  onToggle: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  toggle() {
    this.isActive = !this.isActive;
    this.onToggle.emit(this.isActive);
  }

  setIsActive(isActive) {
    this.isActive = isActive;
    this.onToggle.emit(this.isActive);
  }
}
